import { useEffect } from 'react'
import { useModal } from "../../../hooks/useModal"
import Spinner from '../../ui/spinner';
import { Modal } from "../../ui/modal";
import { ListIcon } from "../../../icons"
import MenuSectionList from '../../../pages/MenuSections/MenuSectionList';
import useMenu from '../../../hooks/Menu/useMenu'

import type { Menu } from "../../../types/menuTypes"

const MenuSections = (menuId: number) => {
  const { isOpen, openModal, closeModal } = useModal();
  const { menu, loading, error, refetchMenu } = useMenu(menuId, {
    fetchPolicy: "network-only",
    refetchOnMount: false,
  });

  useEffect(() => {
    if (!isOpen) {
      refetchMenu()
    }
  }, [isOpen, refetchMenu]);

  if (loading) return <Spinner />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div key={`menu-${menu?.id}`}>
      <button
        onClick={openModal}
        className="flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
      >
        <ListIcon width={24} height={24}/>
        Sections
      </button>
        
      <Modal
        isOpen={isOpen}
        onClose={closeModal}
        showCloseButton
        className="max-w-[700px] max-h-[95vh] overflow-x-auto custom-scrollbar">
          <MenuSectionList menu={menu as Menu} />
      </Modal>
    </div>  
  );
}

export default MenuSections;
